export var Top = 'top';
export var Left = 'left';
export var Right = 'right';
export var Bottom = 'bottom';

export var TopLeft = 'top-left';
export var TopRight = 'top-right';
export var BottomLeft = 'bottom-left';
export var BottomRight = 'bottom-right';

export var Start = 'start';
export var Middle = 'middle';
export var End = 'end';

export var Group = 'group';

export var AxisRole = 'axis';
export var TitleRole = 'title';
export var FrameRole = 'frame';
export var ScopeRole = 'scope';
export var LegendRole = 'legend';

export var RowHeader = 'row-header';
export var RowFooter = 'row-footer';
export var RowTitle  = 'row-title';
export var ColHeader = 'column-header';
export var ColFooter = 'column-footer';
export var ColTitle  = 'column-title';

export var Padding = 'padding';

export var Symbols = 'symbol';

export var Fit  = 'fit';
export var FitX = 'fit-x';
export var FitY = 'fit-y';
export var Pad  = 'pad';
export var None = 'none';

export var All = 'all';
export var Each = 'each';
export var Flush = 'flush';

export var Column = 'column';
export var Row = 'row';


